import { render } from "./DescriptionPage.vue?vue&type=template&id=6e2da2bf"
import script from "./DescriptionPage.vue?vue&type=script&lang=js"
export * from "./DescriptionPage.vue?vue&type=script&lang=js"

import "./DescriptionPage.vue?vue&type=style&index=0&id=6e2da2bf&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__